
export const ENDPOINT_WIZARD_CONTACT_SUPPORT = '/wizard/support/contact/';
export const ENDPOINT_GET_USER_WIZARD_RESPONSES = '/wizard/support/contact/read/';
